import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageReportsService } from 'src/app/_services/messaging/messages/message-reports.service';
import {
  MessageReportModel
} from 'src/app/_models/messaging/messages/message-reports/email-reports/message-report-model';
import {
  MessageReportModelAdapter
} from 'src/app/_models/messaging/messages/message-reports/email-reports/message-report-model.adapter';
import { ListsService } from 'src/app/_services/messaging/lists-and-contacts/lists/lists.service';
import {
  MessageReportLinkClickModelAdapter
} from 'src/app/_models/messaging/messages/message-reports/email-reports/message-report-link-click-model.adapter';
import jsPDF from 'node_modules/jspdf';
import html2canvas from 'node_modules/html2canvas';
import { MessageTypeEnum } from 'src/app/_models/messaging/messages/message-type-enum';
import { NotificationService } from 'src/app/_services/notification.service';
import {
  SMSMessageReportModel
} from 'src/app/_models/messaging/messages/message-reports/sms-reports/sms-message-report-model';
import {
  SMSMessageReportModelAdapter
} from 'src/app/_models/messaging/messages/message-reports/sms-reports/sms-message-report-model.adapter';
import {
  SMSRepliesModelAdapter
} from '../../../../../_models/messaging/messages/message-reports/sms-reports/sms-replies-model.adapter';
import {
  RCSRepliesModelAdapter
} from '../../../../../_models/messaging/messages/message-reports/rcs-reports/rcs-replies-model.adapter';
import { MessageType } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message.model';
import { RCSSuggestionStatsAdapter } from 'src/app/adapters/rcs-suggestion-stats.adapter';
import { RCSSuggestionTypeStatsAdapter } from 'src/app/adapters/rcs-suggestion-type-stats.adapter';
import { RCSInteractionDetailsAdapter } from 'src/app/adapters/rcs-interaction-details.adapter';
import {
  MessageReportLinkClickModel
} from '../../../../../_models/messaging/messages/message-reports/email-reports/message-report-link-click-model';
import { DateService } from '../../../../../_services/system/date.service';
import {
  SMSRepliesModel
} from '../../../../../_models/messaging/messages/message-reports/sms-reports/sms-replies-model';
import { ITableColumns } from '../../../../../_models/tables/table-interfaces';
import { TableService } from '../../../../../_services/tables/table.service';
import { PaginationDataService } from '../../../../../_services/tables/pagination-data/pagination-data.service';
import { ABTestReportsModelAdapter } from 'src/app/_models/messaging/messages/message-reports/email-reports/a-b-test-reports-model.adapter';
import { ABTestReportsModel } from 'src/app/_models/messaging/messages/message-reports/email-reports/a-b-test-reports-model';

@Component({
  selector: 'app-message-report-details',
  templateUrl: './message-report-details.component.html',
  styleUrls: ['./message-report-details.component.scss']
})
export class MessageReportDetailsComponent implements OnInit {
  messageType: MessageTypeEnum;
  messageTypeEnumEmail = MessageTypeEnum.email;
  messageTypeEnumSMS = MessageTypeEnum.sms;
  messageTypeEnumRCS = MessageTypeEnum['rcs-text'];
  reportID: number;
  emailReport: MessageReportModel;
  abTestReport: ABTestReportsModel;
  smsReport: SMSMessageReportModel;
  rcsMessage: any; // RCS message parsed from JSON
  rcsType: string = ''; // RCS message type: text, rich text, carousel
  listName: string;
  downloadingPDF = false;
  displayedColumns: ITableColumns[];
  columnsToDisplay: string[];
  data: any[];
  length: number;
  pageLimit = 10;
  currentPage = 1;
  pageCount = 0;
  pageOffset = 0;
  sortColumn: string = 'UpdatedDate';
  sortDirection: string = 'Descending';
  titlePage: string = "Email Reports";
  showABTestBlock: boolean = false;

  clickedLinks: MessageReportLinkClickModel[];
  paginatedClickedLinks: MessageReportLinkClickModel[][] = [];

  // Delivered Chart Stats
  deliveredChartType = 'pie';
  deliveredChartDatasets: Array<any> = [{data: [], label: '%'}];
  deliveredChartLabels: Array<string> = [];
  deliveredChartColors: Array<any> = [
    {
      backgroundColor: ['#1d1757', '#5fcae1', '#16aceb', '#fc8800', '#ffb134'],
      hoverBackgroundColor: ['#261f69', '#70d1e6', '#2cb7f2', '#ff9c29', '#ffbd54'],
      borderWidth: 2,
    }
  ];
  deliveredChartOptions: any = {
    responsive: true
  };

  // Email Opened Chart Stats
  emailOpenedChartType = 'pie';
  emailOpenedChartDatasets: Array<any> = [{data: [], label: 'label'}];
  emailOpenedChartLabels: Array<string> = [];
  emailOpenedChartColors: Array<any> = [
    {
      backgroundColor: ['#1d1757', '#5fcae1'],
      hoverBackgroundColor: ['#261f69', '#70d1e6'],
      borderWidth: 2,
    }
  ];
  emailOpenedChartOptions: any = {
    responsive: true
  };

    // RCS Suggestion Stats
    rcsSuggestionStats: any[] = [];
    rcsSuggestionTypeChartType = 'pie';
    rcsSuggestionTypeChartDatasets: Array<any> = [{data: [], label: 'Clicks'}];
    rcsSuggestionTypeChartLabels: Array<string> = [];
    rcsSuggestionTypeChartColors: Array<any> = [
      {
        backgroundColor: ['#1d1757', '#5fcae1', '#16aceb', '#fc8800', '#ffb134'],
        hoverBackgroundColor: ['#261f69', '#70d1e6', '#2cb7f2', '#ff9c29', '#ffbd54'],
        borderWidth: 2,
      }
    ];
    rcsSuggestionTypeChartOptions: any = {
      responsive: true,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            const label = data.labels[tooltipItem.index] || '';
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ': ' + value + '%';
          }
        }
      }
    };
    hasRcsSuggestionTypeChartData: boolean = false;

    rcsSuggestionsSentChartType = 'pie';
    rcsSuggestionsSentChartDatasets: Array<any> = [{data: [], label: 'Sent'}];
    rcsSuggestionsSentChartLabels: Array<string> = [];
    rcsSuggestionsSentChartColors: Array<any> = [
      {
        backgroundColor: ['#1d1757', '#5fcae1', '#16aceb', '#fc8800', '#ffb134'],
        hoverBackgroundColor: ['#261f69', '#70d1e6', '#2cb7f2', '#ff9c29', '#ffbd54'],
        borderWidth: 2,
      }
    ];
    rcsSuggestionsSentChartOptions: any = {
      responsive: true
    };
    hasRcsSuggestionsSentChartData: boolean = false;
  
    // RCS Interaction Details
    rcsInteractionDetails: any[] = [];
    rcsInteractionDisplayedColumns: ITableColumns[];
    rcsInteractionColumnsToDisplay: string[];
    rcsInteractionPageLimit = 10;
    rcsInteractionCurrentPage = 1;
    rcsInteractionTotalCount = 0;
  // Clicked Chart Stats
  clickedChartType = 'pie';
  clickedChartDatasets: Array<any> = [{data: [], label: 'label'}];
  clickedChartLabels: Array<string> = [];
  clickedChartColors: Array<any> = [
    {
      backgroundColor: ['#1d1757', '#5fcae1', '#16aceb', '#fc8800'],
      hoverBackgroundColor: ['#261f69', '#70d1e6', '#2cb7f2', '#ff9c29'],
      borderWidth: 2,
    }
  ];
  clickedChartOptions: any = {
    responsive: true
  };

  // SMS Opened Chart Stats
  smsOpenedChartType = 'pie';
  smsOpenedChartDatasets: Array<any> = [{data: [], label: 'label'}];
  smsOpenedChartLabels: Array<string> = [];
  smsOpenedChartColors: Array<any> = [
    {
      backgroundColor: ['#1d1757', '#5fcae1', '#16aceb', '#fc8800', '#ffb134'],
      hoverBackgroundColor: ['#261f69', '#70d1e6', '#2cb7f2', '#ff9c29', '#ffbd54'],
      borderWidth: 2,
    }
  ];
  smsOpenedChartOptions: any = {
    responsive: true
  };

  @ViewChild('pdfContainer') pdfContainer: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private messageReportsService: MessageReportsService,
    private messageReportModelAdapter: MessageReportModelAdapter,
    private listsService: ListsService,
    private messageReportLinkClickModelAdapter: MessageReportLinkClickModelAdapter,
    private router: Router,
    private notificationService: NotificationService,
    private smsMessageReportModelAdapter: SMSMessageReportModelAdapter,
    private smsRepliesModelAdapter: SMSRepliesModelAdapter,
    private rcsRepliesModelAdapter: RCSRepliesModelAdapter,
    private dateService: DateService,
    private tableService: TableService,
    private childPaginationDataService: PaginationDataService,
    private abTestReportsModelAdapter: ABTestReportsModelAdapter,
    private rcsSuggestionStatsAdapter: RCSSuggestionStatsAdapter,
     private rcsSuggestionTypeStatsAdapter: RCSSuggestionTypeStatsAdapter,
     private rcsInteractionDetailsAdapter: RCSInteractionDetailsAdapter
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.reportID = params.reportID;
    });

    this.activatedRoute.data.subscribe(result => {

      if (result.page === 'MessagesReportsEmail') {
        this.displayedColumns = [
          {name: 'link'}
        ];
        this.columnsToDisplay = ['link'];
        this.initEmailReport();
      } else if (result.page === 'MessagesReportsSMS' && result.reportType === 'RCS') {
        this.displayedColumns = [
          {name: 'rcsReplyId', displayName: 'RCSReply ID'},
          {name: 'replyDate', displayName: 'Reply Date'},
          {name: 'rcsMessage', displayName: 'RCS Message Body'},
          {name: 'number', displayName: 'Number'}
        ];
        this.columnsToDisplay = ['rcsReplyId', 'replyDate', 'rcsMessage', 'number'];
        this.initRCSReports();
      } else if (result.page === 'MessagesReportsSMS') {
        this.displayedColumns = [
          {name: 'smsReplyId', displayName: 'SMSReply ID'},
          {name: 'replyDate', displayName: 'Reply Date'},
          {name: 'smsMessage', displayName: 'SMS Message Body'},
          {name: 'number', displayName: 'Number'}
        ];
        this.columnsToDisplay = ['smsReplyId', 'replyDate', 'smsMessage', 'number'];
        this.initSMSReports();
      } else {
        this.router.navigate(['dashboard']);
        this.notificationService.showWarning('Error retrieving the desired Report Type. Please contact an Administrator.');
      }
    });
  }

  initEmailReport(): void {
    this.messageType = MessageTypeEnum.email;
    this.getEmailReportDetails();
    this.getABTestReportDetails();
  }

  initSMSReports(): void {
    this.messageType = MessageTypeEnum.sms;
    this.getSMSReportDetails();
  }

  initRCSReports(): void {
    this.messageType = MessageTypeEnum['rcs-text'];
    this.getRCSReportDetails();
  }

  getEmailReportDetails(): void {
    this.emailReport = this.messageReportModelAdapter.createEmpty();
    this.messageReportsService.getEmailReportDetails(this.reportID).subscribe(result => {
      this.emailReport = this.messageReportModelAdapter.adapt(result.data);
      this.getListName();
      this.populateDeliveredChart();
      this.populateEmailOpenedChart();
      this.populateClickedChart();
      this.tableService.requestTableData();
    });
  }

  getABTestReportDetails(): void {
    this.abTestReport = this.abTestReportsModelAdapter.createEmpty();
    this.messageReportsService.getABTestReportDetails(this.reportID).subscribe(result => {
      this.abTestReport = this.abTestReportsModelAdapter.adapt(result.data); 
      console.log(this.abTestReport);
      this.showABTestBlock = this.abTestReport.HasABData;
    });
  }

  getSMSReportDetails(): void {
    this.smsReport = this.smsMessageReportModelAdapter.createEmpty();
    this.messageReportsService.getSMSReportDetails(this.reportID).subscribe(result => {
      this.smsReport = this.smsMessageReportModelAdapter.adapt(result.data);
      this.listName = this.smsReport.ListName;
      this.populateSMSOpenedChart();
      this.tableService.requestTableData();
    });
  }

  getRCSReportDetails(): void {
    this.smsReport = this.smsMessageReportModelAdapter.createEmpty();
    this.messageReportsService.getRCSReportDetails(this.reportID).subscribe(result => {
      this.smsReport = this.smsMessageReportModelAdapter.adapt(result.data);
      this.listName = this.smsReport.ListName;
      
      // Parse RCS message from MessageBody JSON
      try {
        const messageBody = JSON.parse(this.smsReport.MessageBody);
        
        // Extract and format RCS type for display
        switch(messageBody.type) {
          case 'text':
            this.rcsType = 'Text';
            break;
          case 'richcard':
            this.rcsType = 'Rich Text';
            break;
          case 'carousel':
            this.rcsType = 'Carousel';
            break;
          default:
            this.rcsType = 'Text';
        }
        
        // Transform the message type from string to MessageType enum value
        let transformedMessage: any = { ...messageBody };
        
        // Map RCS type strings to MessageType enum values
        switch(messageBody.type) {
          case 'text':
            transformedMessage.type = MessageType.TEXT;
            break;
          case 'richcard':
            transformedMessage.type = MessageType.STANDALONE;
            break;
          case 'carousel':
            transformedMessage.type = MessageType.CAROUSEL;
            break;
          default:
            transformedMessage.type = MessageType.TEXT;
        }
        
        this.rcsMessage = {
          content: transformedMessage
        };
      } catch (e) {
        console.error('Error parsing RCS message:', e);
        this.rcsMessage = null;
        this.rcsType = '';
      }
      
      this.populateSMSOpenedChart();
      this.tableService.requestTableData();
    });
    
    // Load RCS suggestion statistics
    this.getRCSSuggestionStats();
    this.getRCSSuggestionTypeStats();
    this.getRCSInteractionDetails();
  }

    getRCSSuggestionStats(): void {
      this.messageReportsService.getRCSSuggestionStats(this.reportID).subscribe(result => {
        if (result.data) {
          this.rcsSuggestionStats = result.data.map((item: any) => 
            this.rcsSuggestionStatsAdapter.adapt(item)
          );
        }
      }, error => {
        console.error('Error loading RCS suggestion stats:', error);
      });
    }

    hasCardIndex(cardIndex: number | null | undefined): boolean {
      return cardIndex !== null && cardIndex !== undefined;
    }

    getCardDisplayNumber(cardIndex: number): number {
      return cardIndex + 1;
    }

    formatSuggestionType(type: string): string {
      if (!type) return '';
      
      const typeMap: { [key: string]: string } = {
        'dialPhone': 'Dial Phone',
        'reply': 'Reply',
        'openUrl': 'Open URL',
        'shareLocation': 'Share Location',
        'requestLocationPush': 'Request Location Push',
        'richCard': 'Rich Card',
        'carousel': 'Carousel'
      };
      
      return typeMap[type.toLowerCase()] || type.charAt(0).toUpperCase() + type.slice(1).replace(/([A-Z])/g, ' $1').trim();
    }

    getRCSSuggestionTypeStats(): void {
      this.messageReportsService.getRCSSuggestionTypeStats(this.reportID).subscribe(result => {
        // Reset charts
        this.rcsSuggestionTypeChartDatasets[0].data = [];
        this.rcsSuggestionTypeChartLabels = [];
        this.rcsSuggestionsSentChartDatasets[0].data = [];
        this.rcsSuggestionsSentChartLabels = [];
        this.hasRcsSuggestionTypeChartData = false;
        this.hasRcsSuggestionsSentChartData = false;
        
        if (result.data && result.data.length > 0) {
          result.data.forEach((item: any) => {
            const stats = this.rcsSuggestionTypeStatsAdapter.adapt(item);
            const formattedType = this.formatSuggestionType(stats.suggestionType);
            
            // Interactions chart (Percentage)
            this.rcsSuggestionTypeChartLabels.push(formattedType);
            this.rcsSuggestionTypeChartDatasets[0].data.push(Math.round(stats.interactionPercentage));
            
            // Sent chart (Total Suggestions)
            this.rcsSuggestionsSentChartLabels.push(formattedType);
            this.rcsSuggestionsSentChartDatasets[0].data.push(stats.totalSuggestions);
          });
          
          // Check if charts have data
          this.hasRcsSuggestionTypeChartData = this.rcsSuggestionTypeChartDatasets[0].data.some((val: number) => val > 0);
          this.hasRcsSuggestionsSentChartData = this.rcsSuggestionsSentChartDatasets[0].data.some((val: number) => val > 0);
        }
      }, error => {
        console.error('Error loading RCS suggestion type stats:', error);
        this.hasRcsSuggestionTypeChartData = false;
        this.hasRcsSuggestionsSentChartData = false;
      });
    }

    getRCSInteractionDetails(data?: any): void {
      const pagerModel = {
        page: data?.currentPage || this.rcsInteractionCurrentPage,
        pageSize: data?.pageLimit || this.rcsInteractionPageLimit,
        sortColumn: data?.sortColumn || 'InteractionDate',
        sortDirection: data?.sortDirection || 'Descending'
      };
    
      // Update current page and page limit if provided
      if (data) {
        this.rcsInteractionCurrentPage = data.currentPage;
        this.rcsInteractionPageLimit = data.pageLimit;
      }
    
      this.messageReportsService.getRCSInteractionDetails(this.reportID, pagerModel).subscribe(result => {
        if (result.data) {
          // Backend returns Tuple: Item1 = array of interactions, Item2 = total count
          const interactions = result.data.Item1 || result.data.item1 || [];
          const totalCount = result.data.Item2 || result.data.item2 || 0;
          
          this.rcsInteractionTotalCount = totalCount;
          
          this.rcsInteractionDetails = interactions.map((item: any) => {
            const adapted = this.rcsInteractionDetailsAdapter.adapt(item);
            // Format suggestion type and interaction type
            if (adapted.suggestionType) {
              adapted.suggestionType = this.formatSuggestionType(adapted.suggestionType);
            }
            if (adapted.interactionType) {
              adapted.interactionType = this.formatSuggestionType(adapted.interactionType);
            }
            return adapted;
          });
          
          // Format dates same as RCS Replies
          this.rcsInteractionDetails.forEach((interaction: any) => {
            if (interaction.interactionDate) {
              interaction.interactionDate = this.dateService.formatStringDate(interaction.interactionDate);
            }
          });
        
          // Setup table columns (only on first load)
          if (!this.rcsInteractionDisplayedColumns) {
            this.rcsInteractionDisplayedColumns = [
              {name: 'interactionID', displayName: 'Interaction ID'},
              {name: 'interactionDate', displayName: 'Date'},
              {name: 'suggestionText', displayName: 'Suggestion'},
              {name: 'interactionType', displayName: 'Type'},
              {name: 'number', displayName: 'Number'},
              {name: 'contactID', displayName: 'Contact ID'}
            ];
            this.rcsInteractionColumnsToDisplay = ['interactionID', 'interactionDate', 'suggestionText', 'interactionType', 'number', 'contactID'];
          }
        }
      }, error => {
        console.error('Error loading RCS interaction details:', error);
      });
    }

  getListName(): void {
    this.listsService.getListById(this.emailReport.ListID).subscribe(result => {
      if (result.data[0]) {
        this.listName = result.data[0].ListName;
      }
    });
  }

  populateDeliveredChart(): void {
    const unknown: number = 1 - (this.emailReport.DeliveryRate +
      this.emailReport.FailRate +
      this.emailReport.BounceRate +
      this.emailReport.TemporaryBounceRate);

    this.deliveredChartDatasets[0].data.push(
      (this.emailReport.DeliveryRate * 100).toFixed(2),
      (this.emailReport.FailRate * 100).toFixed(2),
      (this.emailReport.BounceRate * 100).toFixed(2),
      (this.emailReport.TemporaryBounceRate * 100).toFixed(2),
      (unknown * 100).toFixed(2),
    );

    this.deliveredChartLabels = [
      'Delivered', 'Failed', 'Bounced', 'Temp Bounced', 'Queued'
    ];
  }

  populateEmailOpenedChart(): void {
    this.emailOpenedChartDatasets[0].data.push(
      (this.emailReport.OpenRate * 100).toFixed(2),
      (this.emailReport.UnopenRate * 100).toFixed(2),
    );

    this.emailOpenedChartLabels = ['Opened', 'Unopened'];
  }

  populateSMSOpenedChart(): void {
    const unknown: number = ((this.smsReport.TotalSent -
        (this.smsReport.ActivityDelivered +
          this.smsReport.ActivityUndelivered +
          this.smsReport.ActivityBounced +
          this.smsReport.ActivityPending)) /
      this.smsReport.TotalSent);

    this.smsOpenedChartDatasets[0].data.push(
      ((this.smsReport.ActivityDelivered / this.smsReport.TotalSent) * 100).toFixed(2),
      ((this.smsReport.ActivityUndelivered / this.smsReport.TotalSent) * 100).toFixed(2),
      ((this.smsReport.ActivityBounced / this.smsReport.TotalSent) * 100).toFixed(2),
      ((this.smsReport.ActivityPending / this.smsReport.TotalSent) * 100).toFixed(2),
      (unknown * 100).toFixed(2),
    );

    this.smsOpenedChartLabels = ['Delivered', 'Undelivered', 'Bounced', 'Pending', 'Unknown'];
  }

  populateClickedChart(): void {
    const profileUpdated = (this.emailReport.ProfileUpdatedRate).toFixed(2);
    const otherClick = this.emailReport.ProfileUpdatedRate > 0
      ? ((this.emailReport.ClickedRate - this.emailReport.ProfileUpdatedRate)).toFixed(2)
      : 0;
    
    const clicked = ((100 * this.emailReport.Clicked) / this.emailReport.Opened).toFixed(2);
    const notClicked = (100 - +clicked).toFixed(2);

    this.clickedChartDatasets[0].data.push(profileUpdated, otherClick, clicked, notClicked);
    this.clickedChartLabels = ['Profile Updated', 'Other Click', 'Clicked', 'Not Clicked'];
  }

  downloadAsPDF(): void {
    const root = this.pdfContainer.nativeElement as HTMLElement;

    // Copy chart canvases into off-screen static canvases BEFORE pdf-export-mode fires.
    // pdf-export-mode changes chart-width (200%→100%), triggering Chart.js to re-animate —
    // html2canvas would capture the chart mid-animation (a tiny dot). Off-screen copies
    // are static snapshots; drawImage canvas→canvas is synchronous (no async load issues).
    const chartCopies: HTMLCanvasElement[] = Array.from(
      root.querySelectorAll<HTMLCanvasElement>('canvas')
    ).map(liveCanvas => {
      const copy = document.createElement('canvas');
      copy.width = liveCanvas.width;
      copy.height = liveCanvas.height;
      copy.getContext('2d')?.drawImage(liveCanvas, 0, 0);
      return copy;
    });

    this.downloadingPDF = true;

    // Measure page-break positions after applying downloadingPDF (layout may shift).
    const rootTop = root.getBoundingClientRect().top;
    const scale = 2;
    const explicitBreaksPx = Array.from(
      root.querySelectorAll<HTMLElement>('.pdf-page-break')
    )
      .map(el => (el.getBoundingClientRect().top - rootTop) * scale)
      .filter(y => y > 10)
      .sort((a, b) => a - b);

    // Load external images with crossOrigin='anonymous' so they can be drawn to canvas.
    // img.src (DOM property) always returns an absolute URL — more reliable than
    // getAttribute('src') which may differ when Angular sets values via property binding.
    // The browser cache has non-CORS entries for these images, so a cache-buster forces
    // a fresh CORS-enabled request. S3 ignores unknown query params on public GETs.
    const imgDataUrlMap = new Map<string, string>();

    // Collect img src strings (not element refs — Angular may recreate elements after CD).
    const imgSrcs = Array.from(root.querySelectorAll<HTMLImageElement>('img'))
      .map(img => img.src)
      .filter(src => src && !src.startsWith('data:') && !src.startsWith('blob:'));

    const imageFetchPromise = Promise.all(imgSrcs.map(src => new Promise<void>(resolve => {
      try { new URL(src); } catch { resolve(); return; }

      const cacheBusted = src + (src.includes('?') ? '&' : '?') + '_pdf=' + Date.now();
      const corsImg = new Image();
      corsImg.crossOrigin = 'anonymous';
      corsImg.onload = () => {
        try {
          const c = document.createElement('canvas');
          c.width = corsImg.naturalWidth;
          c.height = corsImg.naturalHeight;
          c.getContext('2d')?.drawImage(corsImg, 0, 0);
          imgDataUrlMap.set(src, c.toDataURL('image/jpeg', 0.92));
        } catch { /* drawImage tainted — S3 CORS not returning headers for this image */ }
        resolve();
      };
      corsImg.onerror = () => resolve();
      corsImg.src = cacheBusted;
    })));

    // Wait for both: layout settle (200ms) AND image pre-fetches to complete.
    Promise.all([new Promise(r => setTimeout(r, 200)), imageFetchPromise]).then(() => {
      const captureWidth = Math.max(root.scrollWidth, root.offsetWidth);
      const captureHeight = Math.max(root.scrollHeight, root.offsetHeight);

      // html2canvas ignores onclone src changes for cross-origin images because it
      // pre-caches resource URLs from the original DOM before cloning. Instead, we
      // record each img's rendered position now (after layout settles), let html2canvas
      // render with transparent placeholders, then manually draw our pre-fetched
      // data-URL images onto the final canvas at the recorded coordinates.
      //
      // We must respect overflow:hidden ancestors (e.g. phone preview frame, carousel
      // container) — only the VISIBLE portion of each image is drawn to avoid images
      // from off-screen carousel cards bleeding outside the phone frame.
      const rootRect = root.getBoundingClientRect();

      // Returns the visible clip rect of `el` after intersecting with all
      // overflow-clipping ancestors up to (but not including) `rootEl`.
      const getVisibleClip = (el: HTMLElement, rootEl: HTMLElement): { left: number; top: number; right: number; bottom: number } | null => {
        const r = el.getBoundingClientRect();
        let clip = { left: r.left, top: r.top, right: r.right, bottom: r.bottom };
        let p = el.parentElement;
        while (p && p !== rootEl.parentElement) {
          const s = window.getComputedStyle(p);
          const ovf = s.overflow + ' ' + s.overflowX + ' ' + s.overflowY;
          if (/hidden|clip|scroll|auto/.test(ovf)) {
            const pr = p.getBoundingClientRect();
            clip = {
              left: Math.max(clip.left, pr.left),
              top: Math.max(clip.top, pr.top),
              right: Math.min(clip.right, pr.right),
              bottom: Math.min(clip.bottom, pr.bottom),
            };
          }
          p = p.parentElement;
        }
        return clip.right > clip.left && clip.bottom > clip.top ? clip : null;
      };

      interface ImgOverlay {
        dataUrl: string;
        imgRect: DOMRect;
        visClip: { left: number; top: number; right: number; bottom: number };
      }
      const imgOverlays: ImgOverlay[] = [];

      Array.from(root.querySelectorAll<HTMLImageElement>('img')).forEach(img => {
        const dataUrl = imgDataUrlMap.get(img.src);
        if (!dataUrl) { return; }
        const imgRect = img.getBoundingClientRect();
        const visClip = getVisibleClip(img, root);
        if (!visClip) { return; }  // fully clipped by an overflow:hidden ancestor
        imgOverlays.push({ dataUrl, imgRect, visClip });
      });

      html2canvas(root, {
        allowTaint: false,
        useCORS: false,
        scale,
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
        scrollX: 0,
        scrollY: 0,
        backgroundColor: '#ffffff',
        onclone: (_clonedDoc: Document, clonedRoot: HTMLElement) => {
          // Restore chart canvases from pre-captured off-screen copies.
          const clonedCanvases = Array.from(clonedRoot.querySelectorAll<HTMLCanvasElement>('canvas'));
          chartCopies.forEach((copy, i) => {
            const clone = clonedCanvases[i];
            if (!clone) { return; }
            clone.width = copy.width;
            clone.height = copy.height;
            clone.getContext('2d')?.drawImage(copy, 0, 0);
          });
        }
      } as any).then((h2cCanvas) => {
        // Copy html2canvas output to a fresh canvas to avoid any internal-state issues,
        // then draw our pre-fetched data-URL images on top at the recorded positions.
        const canvas = document.createElement('canvas');
        canvas.width = h2cCanvas.width;
        canvas.height = h2cCanvas.height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(h2cCanvas, 0, 0);

        const overlayPromises = imgOverlays.map(({ dataUrl, imgRect, visClip }) =>
          new Promise<void>(resolve => {
            const image = new Image();
            image.onload = () => {
              // Fraction of the full rendered img that is actually visible
              const fLeft   = (visClip.left   - imgRect.left) / imgRect.width;
              const fTop    = (visClip.top    - imgRect.top)  / imgRect.height;
              const fWidth  = (visClip.right  - visClip.left) / imgRect.width;
              const fHeight = (visClip.bottom - visClip.top)  / imgRect.height;

              // Source rect (in natural image pixels)
              const sx = fLeft   * image.naturalWidth;
              const sy = fTop    * image.naturalHeight;
              const sw = fWidth  * image.naturalWidth;
              const sh = fHeight * image.naturalHeight;

              // Destination rect (in canvas pixels, relative to root)
              const dx = (visClip.left - rootRect.left) * scale;
              const dy = (visClip.top  - rootRect.top)  * scale;
              const dw = (visClip.right  - visClip.left) * scale;
              const dh = (visClip.bottom - visClip.top)  * scale;

              ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh);
              resolve();
            };
            image.onerror = () => resolve();
            image.src = dataUrl;
          })
        );
        return Promise.all(overlayPromises).then(() => canvas);
      }).then((canvas) => {
        try {
          const marginMm = 6;
          const pageWMm = 210;
          const pageHMm = 297;
          const contentWMm = pageWMm - marginMm * 2;
          const contentHMm = pageHMm - marginMm * 2;
          const pxPerMm = canvas.width / contentWMm;
          const maxPageHPx = contentHMm * pxPerMm;

          const doc = new jsPDF('p', 'mm', 'a4');
          let firstPage = true;

          // Sections: each explicit break starts a new page.
          // If a section is taller than one A4, it gets auto-split further.
          const sectionEnds = [...explicitBreaksPx, canvas.height];
          let sectionStart = 0;

          for (const sectionEnd of sectionEnds) {
            let srcY = sectionStart;
            while (srcY < sectionEnd - 1) {
              if (!firstPage) { doc.addPage(); }
              firstPage = false;

              const sliceHPx = Math.min(maxPageHPx, sectionEnd - srcY);
              const sliceHMm = sliceHPx / pxPerMm;

              const sc = document.createElement('canvas');
              sc.width = canvas.width;
              sc.height = Math.round(sliceHPx);
              const ctx = sc.getContext('2d');
              ctx.fillStyle = '#ffffff';
              ctx.fillRect(0, 0, sc.width, sc.height);
              ctx.drawImage(
                canvas,
                0, Math.round(srcY), canvas.width, Math.round(sliceHPx),
                0, 0, canvas.width, Math.round(sliceHPx)
              );
              doc.addImage(sc.toDataURL('image/png'), 'PNG', marginMm, marginMm, contentWMm, sliceHMm);

              srcY += sliceHPx;
            }
            sectionStart = sectionEnd;
          }

          doc.save('Report-Details.pdf');
        } catch (error) {
          console.error('Error generating PDF:', error);
          this.notificationService.showError('Unable to export PDF. Please try again or contact support.');
        }
      }).catch((error) => {
        console.error('Error capturing page:', error);
        this.notificationService.showError('Unable to generate PDF. This may be due to external images in the report.');
      }).finally(() => {
        this.downloadingPDF = false;
      });
    });
  }

  // allows the user to select a filter from the front end when clicking a number
  // and take them to the next page that displays the numbers in a table
  drillDownReport(filter: string): void {
    if (filter.toLowerCase().indexOf('email') > -1) {
      this.router.navigate(['email-reports/details/' + this.reportID + '/', filter]);
    } else if (filter.toLowerCase().indexOf('rcs') > -1) {
      this.router.navigate(['rcs-reports/details/' + this.reportID + '/', filter]);
    } else {
      this.router.navigate(['sms-reports/details/' + this.reportID + '/', filter]);
    }
  }

  // return to the previous page
  goBack(): void {
    this.childPaginationDataService.SetChildPaginationDataToLocalStorage
      (this.currentPage, this.pageLimit, this.sortColumn, this.sortDirection, this.titlePage);
    this.router.navigate([this.router.url.split('/')[1]]);
  }

  getPaginatedClickedLinks(): void {
    const chunkSize = this.pageLimit;
    this.paginatedClickedLinks = [];
    for (let i = 0; i < this.clickedLinks.length; i += chunkSize) {
      const chunk = this.clickedLinks.slice(i, i + chunkSize);
      this.paginatedClickedLinks.push(chunk);
    }
  }

  formatDates(smsReplies: SMSRepliesModel[]): void {
    smsReplies.forEach((reply: SMSRepliesModel) => {
      reply.replyDate = this.dateService.formatStringDate(reply.replyDate);
    });
  }

  getData(data?): void {
    if (this.messageType != MessageTypeEnum.email) {
      const options = {
        ReportID: this.reportID,
        PagerModel: {
          Page: data.currentPage,
          PageSize: data.pageLimit,
          SortColumn: data.sortColumn,
          SortDirection: data.sortDirection
        }
      };

      if (this.messageType === MessageTypeEnum['rcs-text']) {
        this.messageReportsService.getRCSReplies(options).subscribe(result => {
          this.data = this.rcsRepliesModelAdapter.adaptArray(result.data.Item1);
          this.formatDates(this.data);
          this.length = result.data.Item2;
        });
      } else {
        this.messageReportsService.getSMSReplies(options).subscribe(result => {
          this.data = this.smsRepliesModelAdapter.adaptArray(result.data.Item1);
          this.formatDates(this.data);
          this.length = result.data.Item2;
        });
      }
    } else {
      this.messageReportsService.getClickedLinks(this.reportID).subscribe(result => {
        this.clickedLinks = result.data.Item1;
        this.length = result.data.Item2;
        this.pageLimit = data.pageLimit;

        this.getPaginatedClickedLinks();
        this.data = this.paginatedClickedLinks[data.currentPage - 1];
      });
    }
  }
}
